export default {
    debug: false,
}